export default {
    debug: false,
}